export default __webpack_public_path__ + "atomic/_patterns/02-molecules/community-search-teaser/_community-search-teaser.twig";